<template>
<div class="wrap-login">
	<v-flex xs12 sm8 md4>
		<v-card class="elevation-12">
			<v-toolbar dark color="primary">
				<v-toolbar-title>{{$t('login.login_form')}}</v-toolbar-title>
				<v-spacer />
			</v-toolbar>
			<v-card-text>
				<v-form ref="form" v-model="valid" lazy-validation>
					<v-text-field
						prepend-icon="mail"
						:error-messages="auth.loginErrors.email"
						v-model="email"
						name="login"
						:rules="emailRules"
						:label="$t('login.email')"
						type="email"
						v-on:keyup.enter="submit"
					/>
					<v-text-field
						id="password"
						:error-messages="auth.loginErrors.password"
						prepend-icon="lock"
						name="password"
						:rules="passwordRules"
						v-model="password"
						:label="$t('login.password')"
						type="password"
						v-on:keyup.enter="submit"
					/>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer />
				<v-btn
					@click="submit"
					color="primary"
					:loading="auth.isLoading"
				>
					{{$t('login.login')}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-flex>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
	data() {
		return {
			email: '',
			emailRules: [
				v => !!v || this.$t('common.email_required'),
				v => /.+@.+/.test(v) || this.$t('common.email_valid')
			],
			password: '',
			passwordRules: [v => !!v || this.$t('common.password_required'),],
			valid: true
		}
	},
	computed: {
		...mapState(['auth'])
	},
	methods: {
		...mapActions({ login: 'auth/login' }),
		submit() {
			if (!this.$refs.form.validate()) {
				return false
			}
			this.login({
				email: this.email,
				password: this.password
			}).then(() => {
				this.$router.push('/workers')
			})
		}
	}
}
</script>

<style scoped>
.wrap-login {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: #fff;
	z-index: 10000;
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>
